import styles from './ImageHeadingDate.module.css';

const ImageHeadingDate = ({ image, heading, date }) => {
  return (
    <div className={styles.eventCard}>
      <img src={image} alt="event" className={styles.image} />
      <div className={styles.content}>
        <div className={styles.heading}>{heading}</div>
        <div className={styles.date}>{date}</div>
      </div>
    </div>
  );
};

export default ImageHeadingDate;
